<script lang="ts" setup>
  import { defineComponent, onMounted, reactive } from "vue";

  import BreadCrumb from "../../components/Common/BreadCrumb.vue";

  //servicos
  import * as service from "@/services/clientesService";
  import { setaFocus} from "@/utils/funcoes";
  import config from "@/app.config.json";
  
  //componentes
  import Paginador from "@/components/Paginador/Index.vue";
  import DropdownCidadesAtiva from "@/components/Dropdowns/DropdownCidadesAtiva.vue";
  import DropdownVendedores from "@/components/Dropdowns/DropdownVendedores.vue";
  import MsgBox from "@/components/MsgBox/Index.vue";
  
  import { useUserStore } from "@/stores/userStore";

  import { useAcl } from "vue-simple-acl";
  const acl = useAcl();

  const userStore = useUserStore();

  var controle = reactive({
    filtros: {
      comCidades: true,
      ativo: null,
      vendedorId: null,
      paginaAtual: 1,
      tamanhoPagina: 10
    } as unknown as service.Filtros,
    itens: [] as service.Cliente[],
    totalRegistros: 0,

    tipos: ['- Todos -','Particular','Empresarial'] ,
    listaStatus:[
      {valor: null, descricao:"- Todos -"},
      {valor: true, descricao:"Ativos"},
      {valor: false, descricao:"Inativos"},
    ],
    listaCortesia:[
      {valor: null, descricao:"Todos"},
      {valor: true, descricao:"Com Cortesia"},
      {valor: false, descricao:"Sem Cortesia"},
    ],

    itemExcluir: null as service.Cliente | null,
    janExcluir: false,
    status: "",
    erro: "",

    ordenacao: {
      coluna: '',
      asc: true
    },
  })

  onMounted(async ()=>{
    setaFocus("txtPesquisar");
    pesquisar();
  })

  async function pesquisar() {

    if (acl.can("vendedor") && !acl.can("supervisor")) {
      controle.filtros.usuarioId = userStore.user?.usuarioId  || null;
    }

    service.obter(controle.filtros)
    .then(r=> {
      controle.itens = r.dados;
      controle.totalRegistros = r.totalRegistros;
    })
    .catch(erro=> {
      controle.erro = erro;
    })
  }

  function ordenarPor(coluna: string) {
    if (controle.ordenacao.coluna === coluna) {
      controle.ordenacao.asc = !controle.ordenacao.asc;
    } else {
      controle.ordenacao.coluna = coluna;
      controle.ordenacao.asc = true;
    }
    
    controle.itens?.sort((a, b) => {
      let valA = (a as Record<string, any>)[coluna];
      let valB = (b as Record<string, any>)[coluna];
      if (typeof valA === 'string') valA = valA.toLowerCase();
      if (typeof valB === 'string') valB = valB.toLowerCase();
      if (valA < valB) return controle.ordenacao.asc ? -1 : 1;
      if (valA > valB) return controle.ordenacao.asc ? 1 : -1;
      return 0;
    });
  }

  
  function pergExcluir(item: service.Cliente) {
    controle.janExcluir = true;
    controle.itemExcluir = item;
  }

  function excluir() {
    if (controle.itemExcluir) {
      service.excluir(controle.itemExcluir.clienteId)
        .then(() => {
          controle.janExcluir = false;
          pesquisar();
        })
        .catch(erro => {
          controle.erro = erro;
          controle.janExcluir = false;
        });
    }
  }

function painelCliente(item: service.Cliente) {
    service.gerarSenhaTemporaria({clienteId: item.clienteId, minutos: 1440})
      .then(senha => {
        
        window.open(`${config.urlPainelCliente}/Cliente/LoginExterno?clienteId=${item.clienteId}&senha=${senha}`, '_blank');
      })
      .catch(erro => {
        controle.erro = erro;
      });
  }

  async function copiarLink(item: service.Cliente) {
    try {
      var r = await  service.gerarSenhaTemporaria({clienteId: item.clienteId, minutos: 1440});

      var link = `${config.urlPainelCliente}/Cliente/LoginExterno?clienteId=${item.clienteId}&senha=${r}`;

      await navigator.clipboard.writeText(link);
      alert("Link copiado para a área de transferência!");
      controle.status = "Link copiado para a área de transferência!";
    } catch (erro:  any) {
      controle.erro = erro;
    }
    
  }
</script>

<template>
  <BreadCrumb PageTitle="Clientes" />

  <div class="card">
    <div class="card-body">
      <div class="row">
        <div class="col-6 col-md-2">
          <label><i class="flaticon-search"></i> Pesquisar</label>
          <input type="text" 
          class="form-control form-control-sm" 
          placeholder="Nome, código..." 
          v-model="controle.filtros.nome" 
          @keyup="pesquisar" 
          id="txtPesquisar"/>
        </div>

        <div class="col-6 col-md-2">
          <label>Cidade</label>
          <DropdownCidadesAtiva v-model="controle.filtros.cidadeId" @change="pesquisar" />
        </div>

        <div class="col-6 col-md-2" v-if="acl.can('supervisor') || acl.can('admin')">
          <label>Vendedor</label>
           <DropdownVendedores v-model="controle.filtros.usuarioId" @change="pesquisar" />
        </div>

        <div class="col-6 col-md-2">
          <label>Cortesia</label>
           <select class="form-select form-select-sm" v-model="controle.filtros.cortesia" @change="pesquisar">
            <option v-for="(item,idx) in controle.listaCortesia" :value="item.valor" :key="idx">{{ item.descricao }}</option>
          </select>
        </div>

        <div class="col-6 col-md-2">
          <label>Status 2</label>
           <select class="form-select form-select-sm" v-model="controle.filtros.ativo" @change="pesquisar">
            <option v-for="(item,idx) in controle.listaStatus" :value="item.valor" :key="idx">{{ item.descricao }}</option>
          </select>
        </div>

        <div class="col-6 col-md-2">
          <RouterLink class="btn btn-primary btn-sm mt-4 float-end" :to="'/clientes/cadastro'"><i class="flaticon-plus"></i> Adicionar</RouterLink>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-md-12 table-responsive">
          <table class="table  align-middle mb-0 table-hover">
            <thead>
              <tr>
                <th @click="ordenarPor('usuarioId')" class="th-sortable">Id</th>
                <th @click="ordenarPor('nomeCompleto')" class="th-sortable">Nome</th>
                <th @click="ordenarPor('tipoId')" class="th-sortable">CPF</th>
                <th @click="ordenarPor('email')" class="th-sortable">Telefone</th>
                <th @click="ordenarPor('ativo')" class="th-sortable">Celular</th>
                <th @click="ordenarPor('ativo')" class="th-sortable">Cidade</th>
                <th @click="ordenarPor('ativo')" class="th-sortable">Status</th>
                <th>Opções</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item,idx) in controle.itens" :key="idx" class="align-middle">
                <td>
                  <a href="javascript:void(0);" @click="painelCliente(item)"
                    title="Abrir painel do cliente" class="fw-bold text-primary">
                    {{ item.clienteId }}
                  </a>
                </td>
                <td class="nowrap-celular">
                  {{item.nome}} <span v-if="item.cortesia == true">
                    <i class="text-primary flaticon-star-1 ms-1" title="Cortesia"></i>
                  </span>
                </td>
                <td>{{item.cpf}}</td>
                <td class="nowrap-celular">{{item.telefone}}</td>
                <td class="nowrap-celular">{{item.celular}}</td>
                <td>{{item.cidade?.nome}}</td>
                <td>
                  <span class="badge rounded-pill" :class="item.ativo ? 'badge-soft-success' : 'badge-soft-danger'">
                    {{ item.ativo ? 'Ativo' : 'Inativo' }}
                  </span>
                </td>
                <td class="text-center text-nowrap">
                  <span>
                    
                    <a class="" href="javascript:void(0);" 
                     title="Acessar painel do cliente" 
                     @click="painelCliente(item)" >
                        <i  class="flaticon-user fs-5"></i>
                    </a>

                    <a class="ms-2" href="javascript:void(0);" 
                      title="Copiar link do painel do cliente" 
                      @click="copiarLink(item)" >
                        <i  class="fa fa-copy fs-5"></i>
                    </a>

                    <RouterLink :to="'/clientes/cadastro/' + item.clienteId" title="Alterar" class="ms-2">
                        <i class="flaticon-pen fs-5"></i>
                    </RouterLink>

                     <RouterLink :to="`/clientes/cartao/${item.clienteId}`" 
                     v-if="item.permCartao" title="Cartão"
                     v-can="'supervisor'">
                        <i class="flaticon-card fs-5 ms-2 me-2 text-dark"></i>
                    </RouterLink>

                     <a class="ms-2" href="javascript:void(0);" 
                     @click="pergExcluir(item)" title="Excluir"
                     v-can="'supervisor'">
                        <i  class="flaticon-delete fs-5 text-danger"  ></i>
                      </a>
                  </span>

                </td>
              </tr>
            </tbody>
          </table>  
        </div>
      </div>
    </div>
    <div class="card-footer">
       <div class="row mt-2">
        <div class="col-md-4">
           {{ controle.totalRegistros }} Registros
        </div>
        <div class="col-md-6">
          <Paginador class="float-end"
            :paginaAtual="controle.filtros.paginaAtual"
            :tamanhoPagina="controle.filtros.tamanhoPagina"
            :totalRegistros="controle.totalRegistros"
            @on-change="(el) => { 
              controle.filtros.paginaAtual = el.paginaAtual; 
              controle.filtros.tamanhoPagina = el.tamanhoPagina;
              pesquisar() }" />
        </div>
        <div class="col-md-2">
          <RouterLink class="btn btn-secondary btn-sm float-end" :to="'/'">Fechar</RouterLink>
        </div>
      </div>
    </div>
  </div>

    <MsgBox :id="'janExcluir'" :titulo="'Atenção'" :exibir="controle.janExcluir" @onFechou="controle.janExcluir = false"
        :botao-sim="true" :botao-nao="true" @onSim="excluir()" >
      <div class="row">
          <div class="col-md-12 fw-bold fs-6">
              Deseja excluir este registro?
          </div>
      </div>
  </MsgBox>
</template>

<style lang="css" scoped>

  .form-control {
    background: #F5F4FA;
  }

  .th-sortable {
    cursor: pointer;
    user-select: none;
  }

  a {
    text-decoration: none;
  }

  /* Evita quebra de linha nas colunas Nome, Telefone e Celular apenas no celular */
  @media (max-width: 767.98px) {
    .nowrap-celular {
      white-space: nowrap;
    }
  }
</style>